import React from "react";
import "./Portfolio.css"

const PortfolioThree = () => (
  <div className="PortfolioMain">

	<h1>Contact</h1>

	<p><a href={"https://sendgrid.com//"} 
    target={"_blank"}>SendGrid</a> is the company that provides
    the backend mechanism for sending me an e-mail when someone
    clicks the submit button on the "Contact Charles" screen of
    this website.</p>
  </div>
);

export default PortfolioThree;


// WEBPACK FOOTER //
// ./src/components/Portfolio/PortfolioThree.js